import React, { useMemo, useState } from 'react';
import DHeader from '../../pieces/DHeader';
import DText from '../../pieces/DText';
import DCode from '../../pieces/DCode';

import { NodeSpec } from '../../custompieces/NodeSpec';

export default function LLMNodes() {

    return (
        <div>

          


            <DHeader>LLM Nodes</DHeader>

            <DText>
            LLM Nodes are the nodes that are used to interact with LLMs.
            </DText>

            <hr />
       

            <NodeSpec 
            title='OpenAI' 
            dependencies={['OpenAI']} 
            config={['api_key']} 
            inputs={['prompt']} 
            outputs={['response']} 
            description='This node is used to interact with the OpenAI API.' 
            example='This is an example of how to use the OpenAI node.' 
            />
           
            
            {/* <DCode>
                {`python QuickStart.py`}
            </DCode> */}
       
        </div>
    )
}